import { ICartData } from '@features/cart/typescript';
const GoogleAdwordsAddToCart = (products: ICartData[]) => {
  products.forEach((product: ICartData) => {
    if (window?.ga && typeof window.ga === 'function') {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:addProduct', {
        id: product?.productId,
        name: product?.name,
        category: 'product',
        position: 0
      });
      window.ga('ec:setAction', 'add');
      window.ga('send', 'event', 'detail view', 'click', 'addToCart');
    }
  });
};
export default GoogleAdwordsAddToCart;